export const ISIS_TOKEN = window.$environment.ISIS_TOKEN;